import * as angular from 'angular';

"use strict";

angular.module('SidebarPagesModule', [])

export default 'SidebarPagesModule';